import React, { useEffect, useState, useMemo } from 'react'
import api from '../components/api'
import Table from 'react-bootstrap/Table'
import { v4 as uuidv4 } from 'uuid';
import { fmtMoney } from '../components/functions'
import { Link } from 'react-router-dom'

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from './StatusValidacaoSecao'
import { useQuery } from 'react-query'

const DadosGeracao = (props) => {


    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()



    var ano = props.ano
    var login_id = 0
    var adesao_institucional_id = props.adesao_institucional_id
    
    var [residuo_id, setResiduo_id] = useState()



    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()

    const [totalPendencias, setTotalPendencias] = useState(0)

    const [questao, setQuestao] = useState()



    useEffect(() => {

        verificaValidacoes()

    }, [residuo_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao()
        

        if (residuo_id) {

            var dataPost = {

                formulario_id: residuo_id,
                desafio: 'Resíduos',

            }

            

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data, 'valid')
                var totalErros = 0


                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Informe dos dados de geração de resíduos':

                                totalErros = totalErros + 1
                                setQuestao('red')
    
                            break

                            
                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    const currencyConfig = {
        locale: "pt-BR",
        formats: {
          number: {
            BRL: {
              //style: "currency",
              currency: "BRL",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            },
          },
        },
      };

    
    
    
    var [totalResiduos, setTotalResiduos] = useState('')

    var [freqPesagem_id, setFreqPesagem_id] = useState('')
    var [resultadoFreqPesagem, setResultadoFreqPesagem] = useState()

    var [grupoResiduo_id, setGrupoResiduo_id] = useState('')
    var [resultadoGrupoResiduo, setResultadoGrupoResiduo] = useState()

    var [mes, setMes] = useState('')

    var [subGrupoResiduo_id, setSubGrupoResiduo_id] = useState('')
    var [resultadoSubGrupoResiduo, setResultadoSubGrupoResiduo] = useState()

    var [tipoTratamento_id, setTipoTratamento_id] = useState('')
    var [resultadoTipoTratamento, setResultadoTipoTratamento] = useState()

    var [dadosGeracaoDestinacao, setDadosGeracaoDestinacao] = useState([])
    //var [resultadoDadosGeracao, setResultadoDadosGeracao] = useState()
    var [nomeArquivo, setNomeArquivo] = useState('')

    const [totalGrupoA, setTotalGrupoA] = useState()
    const [totalGrupoB, setTotalGrupoB] = useState()
    const [totalGrupoD, setTotalGrupoD] = useState()
    const [totalResiduosEspecificos, setTotalResiduosEspecificos] = useState()
    const [totalGeral, setTotalGeral] = useState()
    const [consolidado, setConsolidado] = useState(false)
    
    /*
    const handleChange = (event, value, maskedValue) => {
        event.preventDefault();

        
        console.log(value); // value without mask (ex: 1234.56)
        return value
        
        //console.log(maskedValue); // masked value (ex: R$1234,56)
    };
    */

    
    /*

    async function carregaFreqPesagem() {
       
        await api.get('freqPesagem').then((result) => {

            setResultadoFreqPesagem(result.data.map((rs) =>

                <option value={rs.freqPesagem_id + '|' + rs.freqPesagem_descri}>{rs.freqPesagem_descri}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })



    }


    
    async function carregaGrupoResiduo() {



        await api.get('grupoResid').then((result) => {

            setResultadoGrupoResiduo(result.data.map((rs) =>

                <option value={rs.grupoResiduo_id + '|' + rs.grupoResiduo_descri}>{rs.grupoResiduo_descri}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    async function carregaSubGrupoResiduos() {


        if (grupoResiduo_id.indexOf('|') != -1) {

            var grupoResid_array = grupoResiduo_id.split('|')

            await api.get(`subGrupoResid/${grupoResid_array[0]}`).then((result) => {

                setResultadoSubGrupoResiduo(result.data.map((rs) =>

                    <option value={rs.subGrupoResiduo_id + '|' + rs.subGrupoResiduo_descri}>{rs.subGrupoResiduo_descri}</option>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })


        }



    }



    async function carregaTipoTratamento() {


        if (subGrupoResiduo_id.indexOf('|') != -1) {

            var subGrupoResid_array = subGrupoResiduo_id.split('|')

            await api.get(`tipoTratamento/${subGrupoResid_array[0]}`).then((result) => {

                setResultadoTipoTratamento(result.data.map((rs) => 
                
                    <option value={rs.tipoTratamento_id + '|' + rs.tipoTratamento_descri}>{rs.tipoTratamento_descri}</option>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    async function carregaDadosGeracao() {

        if (!isNaN(residuo_id)) {

            await api.get(`dadosGeracao/${residuo_id}`).then((result) => {

                //console.log(result.data)
                setDadosGeracaoDestinacao(result.data)

            }).catch((err) => {

                console.log(err.response)

            })

        }
    }


    */

    const { data: resultadoDadosGeracao, isLoading, refetch } = useQuery({

        queryKey: ['dadosGeracao', residuo_id],
        queryFn: async () => {

            try {

                const result = await api.get(`dadosGeracaoNovo/${residuo_id}`)
                //console.log(result.data, 'aquii dados geracao novos')
                return result.data ?? []


            } catch (err) {

                console.log(err.response)
                throw err

            }

        },
        enabled: !!residuo_id

    })



    async function carregaDadosResiduos() {

        api.get(`residuosGestao/${adesao_institucional_id}/${ano}`).then((result) => {

            //console.log(result.data, '!!')

            var data = result.data[0]
            setResiduo_id(data.residuo_id)
            setConsolidado(result.data[0].geracaoCompleto ? result.data[0].geracaoCompleto : false)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    


    function downloadPlanilha() {


        if (nomeArquivo) {


            window.location.href = `${process.env.REACT_APP_API}/uploads/desafioResiduos/${nomeArquivo}`


        }



    }



    async function carregaDadosGestao() {

        if (!isNaN(residuo_id)) {


            await api.get(`residuosGestao/${adesao_institucional_id}/${ano}`).then((result) => {
                //console.log(result.data)


                setNomeArquivo(result.data[0].arquivoEvidencia)

            }).catch((err) => {


            })

        }

    }


    async function carregaSubtotais() {

        if (!isNaN(adesao_institucional_id)) {

            await api.get(`residuosGeracaoSoma/${adesao_institucional_id}/${ano}`).then((result) => {

                var data = result.data[0]
    
                setTotalGrupoA(data.totalGrupoA ? fmtMoney(data.totalGrupoA) : null)
                setTotalGrupoB(data.totalGrupoB ? fmtMoney(data.totalGrupoB) : null)
                setTotalGrupoD(data.totalGrupoD ? fmtMoney(data.totalGrupoD) : null)
                setTotalResiduosEspecificos(data.totalResiduosEspecificos ? fmtMoney(data.totalResiduosEspecificos) : null)
                setTotalGeral(data.totalGeral ? fmtMoney(data.totalGeral) : null)
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })
            

        }

        


    }



    useEffect(() => {

        if (!isNaN(adesao_institucional_id)) {

            setResiduo_id()
            setNomeArquivo('')
            //setResultadoDadosGeracao()
            carregaDadosResiduos()
            //carregaFreqPesagem()
            //carregaGrupoResiduo()
            //carregaDadosResiduos()

        }

        
        

    }, [ano, adesao_institucional_id])
    


    useEffect(() => {

        //carregaDadosGeracao()
        carregaDadosGestao()
        //carregaSubtotais()

    }, [residuo_id])

    

    /*
    useEffect(() => {

        carregaSubGrupoResiduos()
        setResultadoTipoTratamento()

    }, [grupoResiduo_id])


    useEffect(() => {

        carregaTipoTratamento()

    }, [subGrupoResiduo_id])
    */


    function adicionaDadoGeracao() {


        if (mes == '') {

            window.toastr.error('Por favor, informe o <b>Mês em que o resíduo foi gerado</b>')
            return false

        }

        /*
        if (freqPesagem_id == '') {

            window.toastr.error('Por favor, informe a <b>Frequência de Pesagem de RSS</b>')
            return false

        }
        */


        if (grupoResiduo_id == '') {

            window.toastr.error('Por favor, informe o <b>Grupo de Resíduos</b>')
            return false

        }

        if (subGrupoResiduo_id == '') {

            window.toastr.error('Por favor, informe o <b>Subgrupo de Resíduos gerados</b>')
            return false

        }

        if (tipoTratamento_id == '') {

            window.toastr.error('Por favor, informe o <b>Tipo de Tratamento/Destinação</b>')
            return false

        }


        var freqPesagem_array = freqPesagem_id.split('|')
        var grupoResiduo_array = grupoResiduo_id.split('|')
        var subGrupoResiduo_array = subGrupoResiduo_id.split('|')
        var tipoTratamento_array = tipoTratamento_id.split('|')

        //console.log(totalResiduos)
        //return false

        var dadosAdd = {

            mes: mes,
            
            grupoResiduo_id: grupoResiduo_array[0],
            grupoResiduo_descri: grupoResiduo_array[1],
            subGrupoResiduo_id: subGrupoResiduo_array[0],
            subGrupoResiduo_descri: subGrupoResiduo_array[1],
            tipoTratamento_id: tipoTratamento_array[0],
            tipoTratamento_descri: tipoTratamento_array[1],
            totalResiduos: totalResiduos,
            totalResiduosAPI: totalResiduos.replaceAll('.', '').replaceAll(',', '.').replaceAll(' ', ''),
            key: uuidv4(),

        }

        setDadosGeracaoDestinacao([...dadosGeracaoDestinacao, dadosAdd])

        setMes('')
        setFreqPesagem_id('')
        setGrupoResiduo_id('')
        setSubGrupoResiduo_id('')
        setTipoTratamento_id('')
        setTotalResiduos('')

        //console.log(dadosAdd)


    }


    function removeGeracao(key, id) {

        if (id) {

            setDadosGeracaoDestinacao(dadosGeracaoDestinacao.filter(item => item.dadosGeracao_id !== key));
            
        } else {

            setDadosGeracaoDestinacao(dadosGeracaoDestinacao.filter(item => item.key !== key));

        }
        

    }


    /*

    function listaDadosGeracao() {

        

        setResultadoDadosGeracao(dadosGeracaoDestinacao.map((rs) =>

            <tr key={rs.key ? rs.key : rs.dadosGeracao_id}>
                <td>
                    <center>
                    {rs.mes}
                    </center>
                </td>
               
                <td>
                    <center>
                    {rs.grupoResiduo_descri}
                    </center>
                </td>
                <td>
                    <center>
                    {rs.subGrupoResiduo_descri}
                    </center>
                </td>
                <td>
                    <center>
                    {rs.tipoTratamento_descri}
                    </center>
                </td>
                <td>
                    <div align="right">
                    {rs.totalResiduos}
                    </div>
                </td>
                <td>
                    <center><a style={{cursor: 'pointer'}} onClick={() => removeGeracao(rs.key ? rs.key : rs.dadosGeracao_id, rs.dadosGeracao_id ? true : false)}><font color='blue'>[Apagar]</font></a></center>
                </td>
                
            </tr>

        ))


    }


    useEffect(() => {

        //console.log('!')
        listaDadosGeracao()

    }, [dadosGeracaoDestinacao])

    */



    const meses = [
        { titulo: 'Jan', campo: 'janeiroFormatado' },
        { titulo: 'Fev', campo: 'fevereiroFormatado' },
        { titulo: 'Mar', campo: 'marcoFormatado' },
        { titulo: 'Abr', campo: 'abrilFormatado' },
        { titulo: 'Mai', campo: 'maioFormatado' },
        { titulo: 'Jun', campo: 'junhoFormatado' },
        { titulo: 'Jul', campo: 'julhoFormatado' },
        { titulo: 'Ago', campo: 'agostoFormatado' },
        { titulo: 'Set', campo: 'setembroFormatado' },
        { titulo: 'Out', campo: 'outubroFormatado' },
        { titulo: 'Nov', campo: 'novembroFormatado' },
        { titulo: 'Dez', campo: 'dezembroFormatado' },
        { titulo: 'Total', campo: 'totalAnoFormatado' },
    ];



    function salvaDadosGeracao() {


        //console.log(dadosGeracaoDestinacao)
        //return false

        var dataPost = {

            dadosGeracao: dadosGeracaoDestinacao

        }

        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {



                    api.post(`dadosGeracao/${adesao_institucional_id}/${ano}/${login_id}/${residuo_id}`, dataPost).then((result) => {

                        //console.log(result.data)

                        if (result.data.alerta == 'ok') {

                            window.toastr.success('Salvo com sucesso!')
                            props.residuosSS()
                            carregaSubtotais()
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }
            
                    }).catch((err) => {
            
                        console.log(err.response)
            
                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        
    }



        const columns = useMemo(
        () => [

            {
                accessorKey: 'grupoResiduo_descri',
                id: 'grupoResiduo_descri',
                header: 'Grupo de resíduos',
                muiTableHeadCellProps: {
                    align: 'left',
                    sx: {
                        backgroundColor: '#c27b20',
                        color: '#fff',    
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',     
                        fontSize: '11px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',             
                    },
                },
                muiTableBodyCellProps: {
                    align: 'left',
                    sx: {
                        backgroundColor: '#e8e8ee',                        
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        fontSize: '11px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',
                    },
                },
            },

            {
                accessorKey: 'subGrupoResiduo_descri',
                id: 'subGrupoResiduo_descri',
                header: 'Subgrupo de resíduos',
                muiTableHeadCellProps: {
                    align: 'left',
                    sx: {
                        backgroundColor: '#c27b20',
                        color: '#fff',    
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',   
                        fontSize: '11px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',               
                    },
                },
                muiTableBodyCellProps: {
                    align: 'left',
                    sx: {
                        backgroundColor: '#e8e8ee',                        
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        fontSize: '10px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',
                    },
                },
            },

            {
                accessorKey: 'tipoTratamento_descri',
                id: 'tipoTratamento_descri',
                header: 'Tipo Tratamento / Destinação',
                muiTableHeadCellProps: {
                    align: 'left',
                    sx: {
                        backgroundColor: '#c27b20',
                        color: '#fff',    
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',   
                        fontSize: '11px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',               
                    },
                },
                muiTableBodyCellProps: {
                    align: 'left',
                    sx: {
                        backgroundColor: '#e8e8ee',                        
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        fontSize: '11px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',
                    },
                },
            },
            /*
            {
                accessorKey: 'ano',
                header: 'Ano',
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                },
            },
            */

            {
                accessorKey: 'totalAnoFormatado',
                id: 'totalAnoFormatado',
                header: 'Total',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'center',
                    sx: {
                        backgroundColor: '#c0151d',
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: '11px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',
                    },
                },
                muiTableBodyCellProps: {
                    align: 'right',
                    sx: {
                        backgroundColor: '#e3f2fd',
                        fontWeight: 'bold',
                        fontSize: '11px',
                        py: 0.2,
                        px: 0.5,
                        density: 'compact',
                        
                    },
                },
            },

            {
                accessorKey: 'janeiroFormatado',
                header: 'Jan',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'fevereiroFormatado',
                header: 'Fev',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'marcoFormatado',
                header: 'Mar',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'abrilFormatado',
                header: 'Abr',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'maioFormatado',
                header: 'Mai',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'junhoFormatado',
                header: 'Jun',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'julhoFormatado',
                header: 'Jul',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'agostoFormatado',
                header: 'Ago',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'setembroFormatado',
                header: 'Set',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'outubroFormatado',
                header: 'Out',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'novembroFormatado',
                header: 'Nov',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },

            {
                accessorKey: 'dezembroFormatado',
                header: 'Dez',
                size: 100,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },


        ],
        [],
    );
    


    return (

        <div>

                <div style={{ display: residuo_id ? 'none' : 'block'}}>

                    Por favor, preencha os dados de governança no gerenciamento de resíduos primeiro!

                </div>


                <div style={{ display: residuo_id ? 'block' : 'none'}}>

                <Link to='#' style={{ color: questao }} onClick={() => {setEnunciado('Informe dos dados de geração de resíduos');setSecaoEnunciado('Dados Geração');window.$('#modalValidacao').modal('show')}}>
                [Informar inconsistência]</Link>

                {

                    /*


                        
                        <div className="col-md-4" >
                            <div class="form-group" >
                                <label className="control-label"><br/>Mês em que o resíduo foi gerado</label>
                                <select class="form-control" onChange={event => setMes(event.target.value)} value={mes}>
                                    <option value="">[Selecione]</option>
                                    <option value="1">Janeiro</option>
                                    <option value="2">Fevereiro</option>
                                    <option value="3">Março</option>
                                    <option value="4">Abril</option>
                                    <option value="5">Maio</option>
                                    <option value="6">Junho</option>
                                    <option value="7">Julho</option>
                                    <option value="8">Agosto</option>
                                    <option value="9">Setembro</option>
                                    <option value="10">Outubro</option>
                                    <option value="11">Novembro</option>
                                    <option value="12">Dezembro</option>
                                </select>
                                
                                    
                            </div>
                        </div>

                        <div className="col-md-4" style={{ display: 'none'}}>
                            <div class="form-group" >
                                <label className="control-label"><br/>Frequência pesagem de RSS</label>
                                <select class="form-control" onChange={event => setFreqPesagem_id(event.target.value)} value={freqPesagem_id}>
                                    <option value="">[Selecione]</option>
                                    {resultadoFreqPesagem}
                                </select>
                                
                                    
                            </div>
                        </div>

                        <div className="col-md-4"  >
                            <div class="form-group" >
                                <label className="control-label"><br/>Grupo de resíduos</label>
                                <select class="form-control" onChange={event => setGrupoResiduo_id(event.target.value)} value={grupoResiduo_id}>
                                    <option value="">[Selecione]</option>
                                    {resultadoGrupoResiduo}
                                </select>
                                
                                    
                            </div>
                        </div>

                        <div className="col-md-4"  >
                            <div class="form-group" >
                                <label className="control-label"><br/>Subgrupo de resíduos gerados</label>
                                <select class="form-control" onChange={event => setSubGrupoResiduo_id(event.target.value)} value={subGrupoResiduo_id}>
                                    <option value="">[Selecione]</option>
                                    {resultadoSubGrupoResiduo}
                                </select>
                                
                                    
                            </div>
                        </div>

                        <div className="col-md-4"  >
                            <div class="form-group" >
                                <label className="control-label"><br/>Tipo de Tratamento/Destinação</label>
                                <select class="form-control" onChange={event => setTipoTratamento_id(event.target.value)} value={tipoTratamento_id}>
                                    <option value="">[Selecione]</option>
                                    {resultadoTipoTratamento}
                                </select>
                                
                                    
                            </div>
                        </div>


                        <div className="col-md-4"  >
                            <div class="form-group" >
                                <label className="control-label"><br/>Total de resíduos kg/mês</label>
                                <input type="text"  class="form-control" value={totalResiduos}  
                                
                                pattern="^[0-9,]*$" 
                                onChange={(e) =>
                                    setTotalResiduos((v) => (e.target.validity.valid ? e.target.value : v))
                                    }
                                
                                />
                    
                                    
                                
                                    
                            </div>
                        </div>


                        <div className="col-md-4"  >
                            <div class="form-group" >
                                <label className="control-label"><br/>&nbsp;</label>
                                
                                <br/>
                                <button type="button" className="btn btn-success" onClick={() => adicionaDadoGeracao()}>+ Adicionar</button>
                                
                                    
                            </div>
                        </div>



                    */
                }

                    <div className="row" >

                        

                        <div className="col-md-12" style={{ marginTop: 20}}>

                            {
                                /*

                                <br/>
                                    <Table striped bordered hover>

                                        <thead>
                                            <tr style={{ backgroundColor: '#afccc6'}}>
                                            <th>
                                                <center>
                                                Mês
                                                </center>
                                                </th>
                                                
                                                <th>
                                                <center>
                                                Grupo de resíduos
                                                </center>
                                                </th>
                                                <th>
                                                <center>
                                                Subgrupo de resíduos
                                                </center>
                                                </th>
                                                <th>
                                                <center>
                                                Tipo de tratamento/Destinação
                                                </center>
                                                </th>
                                                <th>
                                                    <center>
                                                    Total de resíduos kg/ano
                                                    </center>
                                                </th>
                                                <th>
                                                    <center>
                                                    &nbsp;
                                                    </center>
                                                </th>
                                                
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {resultadoDadosGeracao}
                                        </tbody>

                                    </Table>
                                */
                            }
                            
                                <MaterialReactTable 
                                                    
                                    columns={columns}
                                    data={resultadoDadosGeracao?.totais ?? []}
                                    enableColumnResizing
                                    enableColumnPinning
                                    layoutMode="grid-no-grow"
                                    localization={MRT_Localization_PT_BR}
                                    initialState={{
                                        density: 'compact',
                                        columnPinning: {
                                            left: [
                                                'grupoResiduo_descri',
                                                'subGrupoResiduo_descri',
                                                'tipoTratamento_descri',
                                                'totalAnoFormatado',
                                            ],
                                        },
                                        pagination: {
                                            pageSize: 15,
                                            pageIndex: 0,
                                        },
                                    }}
                                    paginationDisplayOptions={{
                                        showPageSizeSelect: false,
                                    }}
                                    state={{
                                        isLoading,
                                        showProgressBars: isLoading,
                                    }}
                                    renderBottomToolbar={() => null}
                                    muiTableHeadCellProps={{
                                        sx: {
                                            fontSize: '11px',
                                            py: 0.2,
                                            px: 0.5,
                                            density: 'compact',
                                            backgroundColor: '#1976d2',
                                            color: '#fff',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: '11px',
                                            py: 0.2,
                                            px: 0.5,
                                            density: 'compact',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            lineHeight: 1.2,
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                        
                                    onClick: (event) => {
                                     
                                        
                                    },
                                         sx: {
                                            cursor: 'auto', 
                                        },
                                        
                                    })}

                                  
                                />

                            
                            
                        </div>


                        
                        {

                            /*


                                <div style={{ marginTop: 20 }} >

                                    


                                    <div className="row">


                                            

                                            <div className="col-md-12">
                                                <div class="form-group" >
                                                <br/><br/>


                                                <Table striped bordered hover>

                                                    <thead>
                                                        <tr style={{ backgroundColor: '#afccc6'}}>
                                                            <th colspan="2">
                                                                <center>
                                                                Subtotais por Grupo de Resíduos
                                                                </center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style={{ display: totalGrupoA ? 'table-row' : 'none'}}>
                                                                <th>
                                                                    
                                                                    <div align="right">
                                                                        Grupo A + E (Biológicos + Perfurocortantes) 
                                                                    </div>
                                                                    
                                                                </th>
                                                                <td>
                                                                    <div align="right">
                                                                    {totalGrupoA}
                                                                    </div>            
                                                                </td>

                                                            </tr>
                                                        <tr style={{ display: totalGrupoB ? 'table-row' : 'none'}}>                                                    
                                                            <th>
                                                                <div align="right">
                                                                Grupo B (Químicos)
                                                                </div>
                                                            </th>
                                                            <td>
                                                            <div align="right">
                                                            {totalGrupoB}
                                                            </div>  
                                                            </td>
                                                        </tr>
                                                        <tr style={{ display: totalGrupoD ? 'table-row' : 'none'}}>
                                                            <th>
                                                                <div align="right">
                                                                Grupo D (Comum)
                                                                </div>
                                                            </th>
                                                            <td>
                                                                <div align="right">
                                                                {totalGrupoD}
                                                                </div>  
                                                            </td>
                                                        </tr>
                                                    
                                                        <tr style={{ display: totalResiduosEspecificos ? 'table-row' : 'none'}}>
                                                            <th>
                                                                <div align="right">
                                                                Resíduos Específicos
                                                                </div>
                                                            </th>
                                                            <td>

                                                                <div align="right">
                                                                {totalResiduosEspecificos}
                                                                </div>  
                                                                
                                                            </td>
                                                        
                                                            
                                                        </tr>
                                                        <tr style={{ display: totalGeral ? 'table-row' : 'none'}}>
                                                            <th>
                                                                <div align="right">
                                                                <font color='red'>Total Geral</font>
                                                                </div>
                                                            </th>
                                                            <td>

                                                                <div align="right">
                                                                <font color='red'>{totalGeral}</font>
                                                                </div>  
                                                                
                                                            </td>
                                                        
                                                            
                                                        </tr>

                                                    </tbody>
                                                    

                                                </Table>
                                                    
                                                        

                                                </div>
                                            </div>

                                        </div>



                                </div>



                            */
                        }
                                        <div className="col-md-12"  style={{ marginTop: 20 }}>



                                            <Table striped bordered hover responsive>

                                                <thead>

                                                    <tr style={{ backgroundColor: '#3cc8d5', color: '#fff' }}>
                                                        <th colSpan={meses.length}>
                                                            <center>Totais mensais</center>
                                                        </th>
                                                    </tr>

                                                    <tr>
                                                        {meses.map((mes) => (
                                                            <th
                                                                key={mes.campo}
                                                                style={{
                                                                    fontSize: '12px',
                                                                    textAlign: 'right',
                                                                }}
                                                            >
                                                                {mes.titulo}
                                                            </th>
                                                        ))}
                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    <tr>
                                                        {meses.map((mes) => (
                                                            <td
                                                                key={mes.campo}
                                                                style={{
                                                                    fontSize: '12px',
                                                                    textAlign: 'right',
                                                                }}
                                                            >
                                                                {resultadoDadosGeracao?.totaisMensais?.[mes.campo] ?? '0,00'}
                                                            </td>
                                                        ))}
                                                    </tr>

                                                </tbody>

                                            </Table>


                                        </div>

                                    <div className="col-md-4" style={{ marginTop: 20 }}>
                                        <div class="form-group" >


                                            



                                            <Table striped bordered hover>

                                                <thead>
                                                    <tr style={{ backgroundColor: '#d56f3c'}}>
                                                        <th colspan="2">
                                                            <center>
                                                            Total por Grupo de Resíduos
                                                            </center>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {resultadoDadosGeracao?.totalGrupoResiduo?.map((rs) =>
                                                    
                                                        <tr style={{ fontSize: '11px'}}>

                                                            <td>
                                                                {rs.grupoResiduo_descri}
                                                            </td>

                                                            <td style={{ textAlign: 'right'}}>
                                                                {rs.totalAnoFormatado}
                                                            </td>


                                                        </tr>
                                                    
                                                    )}

                                                </tbody>
                                                {
                                                    /*

                                                     <tfoot>
                                                        <tr
                                                            style={{
                                                                fontWeight: 'bold',
                                                                backgroundColor: '#f8f9fa',
                                                                fontSize: '11px',
                                                            }}
                                                        >
                                                            <td>TOTAL</td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                {totalGrupo.toLocaleString('pt-BR', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}
                                                            </td>
                                                        </tr>
                                                    </tfoot>

                                                    */
                                                }
                                               

                                            </Table>

                                        </div>
                                    </div>


                                    <div className="col-md-4" style={{ marginTop: 20 }}>
                                        <div class="form-group" >



                                            <Table striped bordered hover>

                                                <thead>
                                                    <tr style={{ backgroundColor: '#789f69'}}>
                                                        <th colspan="2">
                                                            <center>
                                                            Total por Subgrupo de Resíduos
                                                            </center>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {resultadoDadosGeracao?.totalSubGrupoResiduo?.map((rs) =>
                                                    
                                                        <tr style={{ fontSize: '11px'}}>

                                                            <td>
                                                                {rs.subGrupoResiduo_descri}
                                                            </td>

                                                            <td style={{ textAlign: 'right'}}>
                                                                {rs.totalAnoFormatado}
                                                            </td>


                                                        </tr>
                                                    
                                                    )}
                                                </tbody>
                                                {

                                                    /*

                                                    <tfoot>

                                                        <tr style={{ fontSize: '11px', fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                                            <td>TOTAL</td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                {totalSubGrupo.toLocaleString('pt-BR', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}
                                                            </td>
                                                        </tr>
                                                    </tfoot>

                                                    */

                                                }
                                                

                                            </Table>

                                        </div>
                                    </div>

                                    <div className="col-md-4" style={{ marginTop: 20 }}>
                                        <div class="form-group" >



                                            <Table striped bordered hover>

                                                <thead>
                                                    <tr style={{ color: '#FFF', backgroundColor: '#0c1a07'}}>
                                                        <th colspan="2">
                                                            <center>
                                                            Total por Tratamento de Resíduos
                                                            </center>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {resultadoDadosGeracao?.totalTipoTratamento?.map((rs) =>
                                                    
                                                        <tr style={{ fontSize: '11px'}}>

                                                            <td>
                                                                {rs.tipoTratamento_descri}
                                                            </td>

                                                            <td style={{ textAlign: 'right'}}>
                                                                {rs.totalAnoFormatado}
                                                            </td>


                                                        </tr>
                                                    
                                                    )}


                                                </tbody>
                                                {
                                                    /*
                                                }
                                                <tfoot>

                                                    <tr style={{ fontSize: '11px', fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                                        <td>TOTAL</td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            {totalTratamento.toLocaleString('pt-BR', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}
                                                        </td>
                                                    </tr>

                                                </tfoot>
                                                {
                                                    */
                                                }

                                            </Table>

                                        </div>
                                    </div>





                        <div style={{ display: residuo_id ? 'block' : 'none'}} >

                            


                            <div className="row">

                                    <div className="col-md-6">
                                        <div class="form-group" >
                                        <br/><br/>
                                            <label className="control-label">Situação do preenchimento:</label>
                                            <input type="text" className="form-control" value={consolidado == false ? 'Desejo inserir mais combinações de resíduos' : 'Concluí as combinações de resíduos cadastradas'} readOnly />
                                                

                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div class="form-group" >
                                        <br/><br/>
                                            <label className="control-label">Planilha de evidência de pesagem dos dados de resíduos:</label>
                                            <input type="text" className="form-control" value={nomeArquivo} readOnly style={{ cursor: nomeArquivo ? 'pointer' : 'auto'}} onClick={() => downloadPlanilha()} />
                                                

                                        </div>
                                    </div>

                                </div>



                        </div>
                        


                    </div>

                </div>




                <StatusValidacaoSecao desafio="Resíduos" secaoCampo="secaoGeracao" totalPendencias={totalPendencias} nomeDesafio="Desafio Resíduos" formulario_id={residuo_id} secao="Geração" adesao_institucional_id={adesao_institucional_id} ano={ano} />
                

        </div>
    )

}

export default DadosGeracao